import type { Price } from './types';

const MAX_PRICE_MINOR = 10_000_000; // ₱100,000.00

/** Cost of `count` cigarettes, in centavos. Pack prices round the total, so 3 of a ₱100/3 pack = ₱100. */
export function costOf(count: number, price: Price): number {
  switch (price.kind) {
    case 'pack':
      return Math.round((count * price.packPriceMinor) / price.perPack);
    case 'stick':
      return count * price.stickPriceMinor;
    case 'none':
      return 0;
  }
}

const okMinor = (n: number) => Number.isInteger(n) && n > 0 && n <= MAX_PRICE_MINOR;

export function validatePrice(p: Price): 'bad_price' | null {
  if (p.kind === 'pack') {
    return okMinor(p.packPriceMinor) &&
      Number.isInteger(p.perPack) &&
      p.perPack >= 1 &&
      p.perPack <= 100
      ? null
      : 'bad_price';
  }
  if (p.kind === 'stick') return okMinor(p.stickPriceMinor) ? null : 'bad_price';
  return null;
}
